// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__MszbV","drawer":"styles_drawer__2BESX","text":"styles_text__3ncBZ","buttonGroup":"styles_buttonGroup__3AmgE","searchInput":"styles_searchInput__3i-_p"};